export default "__VITE_ASSET__c8swWTz3__"